import { create } from 'zustand'

interface IncognitoState {
  isIncognito: boolean
  toggle: () => void
  enable: () => void
  disable: () => void
}

export const useIncognitoStore = create<IncognitoState>((set) => ({
  isIncognito: false,
  toggle: () => set((s) => ({ isIncognito: !s.isIncognito })),
  enable: () => set({ isIncognito: true }),
  disable: () => set({ isIncognito: false }),
}))
